import React, { ChangeEvent } from 'react';
import { Button, Input, message, Tooltip, Typography } from 'antd';
import { CopyOutlined } from '@ant-design/icons';
import { QRCodeSVG } from 'qrcode.react';

interface MfaSetupFormProps {
  otpAuthUrl: string;
  totpSecret: string;
  verificationCode: string;
  setVerificationCode: (code: string) => void;
  setAuthStep: (step: 'login' | 'mfa-setup' | 'mfa-verification') => void;
  handleVerifyTotp: () => void;
  verifying: boolean;
  buttonStyle: React.CSSProperties;
  buttonBackStyle: React.CSSProperties;
  inputStyle: React.CSSProperties;
}

const MfaSetupForm: React.FC<MfaSetupFormProps> = ({
  otpAuthUrl,
  totpSecret,
  verificationCode,
  setVerificationCode,
  setAuthStep,
  handleVerifyTotp,
  verifying,
  buttonStyle,
  buttonBackStyle,
  inputStyle,
}) => {
  return (
    <div className='space-y-6'>
      <h2 className='text-xl font-semibold'>MFA Setup Required</h2>
      <p>Scan this QR code with your authenticator app</p>

      <div className='border p-4 flex justify-center'>
        {otpAuthUrl && <QRCodeSVG value={otpAuthUrl} size={250} level='H' />}
      </div>

      <div className='text-center'>
        <p className='mb-2'>Or enter this code manually:</p>
        <div className='flex items-center justify-center'>
          <code className='bg-gray-100 px-2 py-1 rounded text-base font-bold'>{totpSecret}</code>
          <Tooltip title='Copy to clipboard'>
            <Button
              type='text'
              icon={<CopyOutlined />}
              onClick={() => {
                navigator.clipboard.writeText(totpSecret);
                message.success('Secret copied to clipboard');
              }}
            />
          </Tooltip>
        </div>
      </div>

      <div className='space-y-4'>
        <div>
          <Typography.Text>Verification Code *</Typography.Text>
          <Input
            value={verificationCode}
            onChange={(e: ChangeEvent<HTMLInputElement>) =>
              setVerificationCode(e.target.value.replace(/[^0-9]/g, ''))
            }
            placeholder='Enter 6-digit code'
            maxLength={6}
            type='tel'
            autoFocus
            onPressEnter={handleVerifyTotp}
            style={inputStyle}
          />
        </div>

        <div className='flex space-x-4'>
          <Button
            onClick={() => setAuthStep('login')}
            className='flex-1'
            style={buttonBackStyle}
            type='default'
          >
            Back
          </Button>
          <Button
            type='primary'
            onClick={handleVerifyTotp}
            className='flex-1'
            loading={verifying}
            style={buttonStyle}
          >
            Verify
          </Button>
        </div>
      </div>
    </div>
  );
};

export default MfaSetupForm;
